import { IClassroom } from '../../../interfaces/classrooms';
import { ReactNode } from 'react';
import { Space, Table, TableProps } from 'antd';
import { TextField } from '@refinedev/antd';
import { formatDate } from '../../../services/date';

interface ClassroomTableProps {
  tableProps: TableProps<IClassroom>;
  children: ReactNode;
}

export const ClassroomTable = ({
  tableProps,
  children
}: ClassroomTableProps) => {
  return (
    <Table {...tableProps} rowKey="id" tableLayout="fixed">
      <Table.Column
        dataIndex="code"
        key="code"
        title="Código"
        width={130}
        render={value => <TextField value={value} />}
        fixed="left"
      />
      <Table.Column<IClassroom>
        dataIndex="discipline"
        key="discipline"
        title="Disciplina"
        width={200}
        sorter
        render={value => <TextField value={value.name} />}
      />
      <Table.Column<IClassroom>
        dataIndex="auto_enroll"
        key="auto_enroll"
        title="Inscrição automática"
        width={100}
        align="center"
        render={value => <TextField value={value ? '✅' : '❌'} />}
      />
      <Table.Column<IClassroom>
        key="seats"
        title="Vagas Ocupadas / Total de vagas"
        width={160}
        align="center"
        render={(_, record) => (
          <TextField
            value={`${Number(record.active_enrollments_count)} de ${Number(
              record.seats_total
            )}`}
          />
        )}
      />
      <Table.Column<IClassroom>
        width={70}
        dataIndex="academic_year"
        key="academic_year"
        title="Ano"
        align="center"
        sorter
        render={value => <TextField value={value ?? '-'} />}
      />
      <Table.Column<IClassroom>
        width={70}
        dataIndex="academic_period"
        key="academic_period"
        title="Período"
        align="center"
        render={value => <TextField value={value ?? '-'} />}
      />
      <Table.Column<IClassroom>
        key="starts_at"
        dataIndex="starts_at"
        title="Vigência"
        width={200}
        sorter
        render={(_, record) => (
          <TextField
            value={
              <Space direction="vertical" align="start" className="text-xs">
                <div>De: {formatDate(record.starts_at, 'lll')}</div>
                <div>Até: {formatDate(String(record.ends_at), 'lll')}</div>
              </Space>
            }
          />
        )}
      />
      {children}
    </Table>
  );
};
